import { Box, Grid } from "@radix-ui/themes";
import { FC } from "react";
import PrecisionGameUIActivity from "./precision.game.ui.activity";
import PrecisionGameUIWinners from "./precision.game.ui.winners";
import PrecisionGameUIMentions from "./precision.game.ui.mentions";

interface PrecisionGameUIProps {
  collection: string;
  winners: string;
  mentions: string;
}

const PrecisionGameUI: FC<PrecisionGameUIProps> = ({
  collection,
  winners,
  mentions,
}): JSX.Element => {
  return (
    <>
      <Grid
        columns={{ initial: "1", lg: "12" }}
        gap={{ initial: "3", lg: "8" }}
      >
        <Box gridColumn={{ initial: "1 / -1", lg: "1 / 7" }}>
          <PrecisionGameUIActivity collection={collection} />
        </Box>
        <Box gridColumn={{ initial: "1 / -1", lg: "7 / 10" }}>
          <PrecisionGameUIWinners collection={collection} headline={winners} />
        </Box>
        <Box gridColumn={{ initial: "1 / -1", lg: "10 / 13" }}>
          <PrecisionGameUIMentions
            collection={collection}
            headline={mentions}
          />
        </Box>
      </Grid>
    </>
  );
};

export default PrecisionGameUI;
